// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.VscOpenPreview = function VscOpenPreview(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 16 16",
      "fill": "currentColor"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fillRule": "evenodd",
        "clipRule": "evenodd",
        "d": "M2 1h11l1 1v5.3a3.21 3.21 0 0 0-1-.3V2H8v10.88L6.88 14H2l-1-1V2l1-1zm0 12h5V2H2v11zm10.409-4.998a2.53 2.53 0 0 0-1.189.348h-.03a2.51 2.51 0 0 0-.8 3.53l-2.36 2.35.71.71 2.35-2.36c.325.22.7.358 1.09.4.385.047.776.002 1.14-.13a2.51 2.51 0 0 0 1-.63 2.46 2.46 0 0 0 .58-1 2.63 2.63 0 0 0 .07-1.15 2.529 2.529 0 0 0-1.35-1.81 2.53 2.53 0 0 0-1.211-.258zm.24 3.992a1.5 1.5 0 0 1-.979-.244 1.55 1.55 0 0 1-.56-.68 1.49 1.49 0 0 1-.08-.86 1.49 1.49 0 0 1 1.18-1.18 1.49 1.49 0 0 1 .86.08c.276.117.512.311.68.56a1.5 1.5 0 0 1-1.1 2.324z"
      }
    }]
  })(props);
};